import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('noora_token');
        const savedUser = localStorage.getItem('noora_user');
        if (token && savedUser) {
            setUser(JSON.parse(savedUser));
            authAPI.me().then(res => {
                setUser(res.data.user);
                localStorage.setItem('noora_user', JSON.stringify(res.data.user));
            }).catch(() => {
                localStorage.removeItem('noora_token');
                localStorage.removeItem('noora_user');
                setUser(null);
            });
        }
        setLoading(false);
    }, []);

    const login = async (username, password) => {
        const res = await authAPI.login({ username, password });
        localStorage.setItem('noora_token', res.data.token);
        localStorage.setItem('noora_user', JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data;
    };

    const changePassword = async (currentPassword, newPassword) => {
        const res = await authAPI.changePassword({ currentPassword, newPassword });
        localStorage.setItem('noora_token', res.data.token);
        localStorage.setItem('noora_user', JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data;
    };

    const logout = () => {
        localStorage.removeItem('noora_token');
        localStorage.removeItem('noora_user');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, changePassword, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
